var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3069 10.7944C13.9345 11.3064 12.4332 11.3605 11.0275 10.9488C9.62172 10.5371 8.38692 9.68158 7.50755 8.5101C6.62819 7.33861 6.15147 5.91405 6.14863 4.44924C6.14578 2.98444 6.61696 1.55803 7.49177 0.38314C6.84902 0.456744 6.21812 0.611147 5.61402 0.842691C3.6664 1.59439 2.09716 3.08898 1.25151 4.99769C0.405864 6.90639 0.353082 9.07285 1.10478 11.0205C1.85647 12.9681 3.35107 14.5373 5.25977 15.383C7.16848 16.2286 9.33494 16.2814 11.2826 15.5297C12.3855 15.1029 13.3765 14.4299 14.1799 13.5621C14.9834 12.6943 15.5782 11.6545 15.9189 10.522C15.7197 10.6231 15.5154 10.714 15.3069 10.7944V10.7944Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.99c5d3337ad4ad4e1f9f08b5a91b1103.svg";
export { ForwardRef as ReactComponent };